<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale} = useI18n()
const currentLang = ref(locale.value)
const availableLanguages = ['en', 'es', 'pt']

const flags = {
  en: '🇺🇸',
  es: '🇪🇸',
  pt: '🇧🇷'
}

onMounted(() => {
  const browserLang = navigator.language.split('-')[0]
  if (availableLanguages.includes(browserLang)) {
    currentLang.value = browserLang
    locale.value = browserLang
  }
})

const switchLanguage = (lang) => {
  currentLang.value = lang
  locale.value = lang
  localStorage.setItem('userLanguage', lang)
};
</script>
<template>
  <div class="language-switcher">
    <select v-model="currentLang" @change="switchLanguage(currentLang)">
      <option v-for="lang in availableLanguages" :key="lang" :value="lang">
        {{ flags[lang] }} 
      </option>
    </select>
  </div>
</template>
<style scoped>
.language-switcher select {
  padding: 2px 4px;
  border-radius: 4px;
  border: 1px solid #ddd;
font-size: 1rem;
}
</style>